var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 25.625V4.375C3.75 3.6375 4.175 2.9875 4.8 2.6875L17.1125 15L4.8 27.3125C4.175 27 3.75 26.3625 3.75 25.625ZM21.0125 18.9L7.5625 26.675L18.175 16.0625L21.0125 18.9ZM25.2 13.5125C25.625 13.85 25.9375 14.375 25.9375 15C25.9375 15.625 25.6625 16.125 25.225 16.475L22.3625 18.125L19.2375 15L22.3625 11.875L25.2 13.5125ZM7.5625 3.325L21.0125 11.1L18.175 13.9375L7.5625 3.325Z",
    fill: "#64737E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.07a3ec6c02b9fd6447b926a7440f6d74.svg";
export { ForwardRef as ReactComponent };